<script setup lang="ts">
import ProjectFilesWaitingRoomBlock from '@/components/projects/file-management/ProjectFilesWaitingRoomBlock.vue'
import { useResizableDialog } from '@/helpers/composables/useResizableDialog'

type CampaignOption = {
  id: number
  name: string
  type?: number
  event_group?: number | null
  event_group_name?: string | null
}

interface Props {
  modelValue: boolean
  defaultProjectTypeId?: number | null
  initialProjects?: CampaignOption[]
}

withDefaults(defineProps<Props>(), {
  modelValue: false,
  initialProjects: () => [],
})

interface Emit {
  (e: 'update:modelValue', value: boolean): void
}

const emit = defineEmits<Emit>()

const {
  dialogWidth,
  dialogHeight,
  dialogMinWidth,
  dialogMinHeight,
} = useResizableDialog({
  defaultWidth: 1520,
  defaultHeight: 820,
  minWidth: 900,
  minHeight: 560,
})

const closeDialog = () => {
  emit('update:modelValue', false)
}

const handleOpenPage = () => {
  closeDialog()
}
</script>

<template>
  <VDialog
    :model-value="modelValue"
    max-width="95vw"
    max-height="95vh"
    :width="dialogWidth"
    :height="dialogHeight"
    class="waiting-room-resizable-dialog"
    @update:modelValue="(value: boolean) => emit('update:modelValue', value)"
  >
    <DialogResizeHandle
      v-model:dialogWidth="dialogWidth"
      v-model:dialogHeight="dialogHeight"
      :min-width="dialogMinWidth"
      :min-height="dialogMinHeight"
    />

    <VCard class="waiting-room-dialog-card d-flex flex-column h-100">
      <VCardTitle class="vss-movable d-flex align-center">
        <MovableDialog />
        <span>Waiting Room</span>
        <VSpacer />
        <VBtn
          icon="mdi-close"
          variant="text"
          size="small"
          @click="closeDialog"
        />
      </VCardTitle>

      <VCardText class="waiting-room-dialog-content pt-1">
        <ProjectFilesWaitingRoomBlock
          :active="modelValue"
          :default-project-type-id="defaultProjectTypeId"
          :initial-projects="initialProjects"
          @open-page="handleOpenPage"
        />
      </VCardText>
    </VCard>
  </VDialog>
</template>

<style scoped lang="scss">
:deep(.waiting-room-resizable-dialog .v-overlay__content) {
  max-width: 95vw;
  max-height: 95vh;
}

.waiting-room-dialog-card {
  position: relative;
  overflow: hidden;
}

.waiting-room-dialog-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
</style>
